// Unused function to init rem, replaced by script tag in _app.tsx
const remInit = () => {
  const setFontSize = () => {
    let width = document.documentElement.clientWidth;
    let fontSize = 0;

    if (width > 992) {
      width = width > 1920 ? 1920 : width;
      fontSize = (width / 1920) * 100;
    } else {
      width = width > 768 ? 768 : width;
      fontSize = (width / 375) * 100;
    }

    document.getElementsByTagName('html')[0].style.fontSize = `${fontSize}px`;
  };
  setFontSize();
  window.addEventListener('resize', setFontSize);
};

export default remInit;
